import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {createAdmin} from "@/lib/axios";

import InstallerContext from "@/context/InstallerContext";

import Step from "@/components/Step";
import StepTitle from "@/components/StepTitle";
import PrevButton from "@/components/PrevButton";
import NextButton from "@/components/NextButton";
import BackgroundCard from "@/components/BackgroundCard";
import ButtonWrapper from "@/components/ButtonWrapper";
import ErrorMessage from "@/components/ErrorMessage";
import Label from "@/components/Label";
import InputGroup from "@/components/InputGroup";
import FormGroup from "@/components/FormGroup";
import Input from "@/components/Input";
import InputGrid from "@/components/InputGrid";
import {Else, If, Then} from "react-if";
import LoginWithButton from "@/components/LoginWithButton";
import StepDescription from "@/components/StepDescription";

const CreateAdmin = ({nextStep, previousStep}) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const {data, updateAdminData} = useContext(InstallerContext)
  const {loginProvider, admin} = data;
  
  const handleNextStep = (e) => {
    e.preventDefault();
    setLoading(true);
    createAdmin(admin, loginProvider)
        .then(({data}) => {
          if (data.errors) {
            setErrors(data.errors);
          } else {
            setErrors([]);
            nextStep();
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
  };
  const [isFilled, setIsFilled] = useState(false);
  
  // Check if all fields are filled
  useEffect(() => {
    if (loginProvider === "default" && admin.realname && admin.email && admin.password && admin.confirmPassword && admin.confirmPassword === admin.password) {
      setIsFilled(true);
    } else if (loginProvider !== "default" && admin.username) {
      setIsFilled(true);
    } else {
      setIsFilled(false);
    }
  }, [admin, setIsFilled]);
  
  const disabled = loading || !isFilled
  
  return (
      <Step>
        <StepTitle>
          {t('steps.3.title')}
        </StepTitle>
        
        <StepDescription>
          {t(loginProvider === "default" ? 'steps.3.description_for_default' : 'steps.3.description_for_oauth')}
        </StepDescription>
        
        <ErrorMessage errors={errors}/>
        
        <BackgroundCard>
          <If condition={loginProvider === "default"}>
            <Then>
              <FormGroup>
                <Label htmlFor="email">
                  {t('steps.3.inputs.email')}
                </Label>
                <InputGroup error={admin.email === ''}>
                  <Input
                      type="email"
                      id="email"
                      placeholder="example: admin@gmail.com"
                      value={admin.email || ""}
                      autoComplete="email"
                      onChange={e => updateAdminData('email', e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="username">
                  {t('steps.3.inputs.username')}
                </Label>
                <InputGroup error={admin.realname === ''}>
                  <Input
                      type="text"
                      id="username"
                      placeholder="example: LeaderOS"
                      value={admin.realname || ""}
                      onChange={e => updateAdminData('realname', e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <InputGrid>
                <FormGroup>
                  <Label htmlFor="password">
                    {t('steps.3.inputs.password')}
                  </Label>
                  <InputGroup error={admin.password === ''}>
                    <Input
                        type="password"
                        id="password"
                        placeholder="**********"
                        value={admin.password || ""}
                        autoComplete="new-password"
                        onChange={e => updateAdminData('password', e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="confirmPassword">
                    {t('steps.3.inputs.confirm_password')}
                  </Label>
                  <InputGroup
                      error={admin.confirmPassword === '' || (admin.confirmPassword !== null && admin.confirmPassword !== admin.password)}>
                    <Input
                        type="password"
                        id="confirmPassword"
                        placeholder="**********"
                        value={admin.confirmPassword || ""}
                        autoComplete="new-password"
                        onChange={e => updateAdminData('confirmPassword', e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              </InputGrid>
            </Then>
            <Else>
              <LoginWithButton provider={loginProvider}/>
            </Else>
          </If>
        </BackgroundCard>
        
        <ButtonWrapper>
          <PrevButton previousStep={previousStep}/>
          <NextButton nextStep={handleNextStep} disabled={disabled} loading={loading}/>
        </ButtonWrapper>
      </Step>
  );
};

export default CreateAdmin;